/** @jsx jsx */
import { jsx } from '@emotion/react'
import './style.css'
import { globalMenuItems, menuItems as originalMenuItems } from './menuItemList'
import TopNavToggle from '../common/top-nav/top-nav-toggle'
import { useApplicationContext } from '../../context/ApplicationContext'
import { useEffect, useState } from 'react'
import LeftSideBarMenu from './LeftSideBarMenu'
import { isPartnerSetupSelfServeEligible } from '../../utils/elmo-utils'

const ENVIRONMENT_PLACEHOLDER = 'ENVIRONMENT'

const LeftSideBarNav = () => {
  const { enviroment, devdash_partner_setup_selfserve_elmo_eligibility } =
    useApplicationContext()
  const [mainMenuLinks, setMainMenuLinks] = useState(originalMenuItems)

  useEffect(() => {
    // Replace ENVIRONMENT placeholder in all menu paths and submenu paths
    const updatedMenuLinks = originalMenuItems
      .filter(
        (item) =>
          item.path !== '/partner-setup' ||
          isPartnerSetupSelfServeEligible(
            enviroment,
            devdash_partner_setup_selfserve_elmo_eligibility,
          ),
      )
      .map((item) => {
        // Remove 'Transactions' submenu in sandbox
        let submenu = item.submenu
        if (enviroment === 'sandbox' && submenu) {
          submenu = submenu.filter((child) => child.label !== 'Transactions')
        }
        // Replace ENVIRONMENT in submenu paths
        if (submenu) {
          submenu = submenu.map((subItem) => ({
            ...subItem,
            path: subItem.path?.replace(ENVIRONMENT_PLACEHOLDER, enviroment),
          }))
        }
        // Replace ENVIRONMENT in main path
        const resolvedPath = item.path?.replace(
          ENVIRONMENT_PLACEHOLDER,
          enviroment,
        )
        return {
          ...item,
          path: resolvedPath,
          submenu,
        }
      })

    setMainMenuLinks(updatedMenuLinks)
  }, [enviroment, devdash_partner_setup_selfserve_elmo_eligibility])

  return (
    <div
      id="merchant-header-main-wrapper-internal"
      className="desktopLeftNavBarStyle"
      data-testid="HeaderComponent"
      role="banner"
    >
      <div className="dev-dash-v5-sidebar">
        <div className="dev-dash-v5-logo">
          <img src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-wordmark-color.svg" />
        </div>

        <div>
          <div className="header-toggle" id="toggle_sandbox_live">
            <TopNavToggle />
          </div>
        </div>

        <div className="header-nav__scrollable">
          <LeftSideBarMenu menuItems={[...mainMenuLinks, ...globalMenuItems]} />
        </div>
      </div>
    </div>
  )
}

export default LeftSideBarNav
